import {
    BackendType,
    convertIsoDateStringToDate,
    FrontendType,
    Gender,
    ObjectType,
    StarjackDate,
    StarjackDateISO,
} from '@/models/general';
import { convertTicketToFrontend, Ticket } from '@/models/ticket';
import { convertDateFromDateArray } from '@/utils/time';

export enum KeycardStatus {
    ORDERED = 'ORDERED',
    LOCKED = 'LOCKED',
    NEW = 'NEW',
    ORDERED_INTERNAL = 'ORDERED_INTERNAL',
    PRODUCED = 'PRODUCED',
}

export type Keycard<T extends ObjectType = FrontendType> = {
    birthday: StarjackDate<T>;
    cardType: string;
    compatibility: ('SKIDATA' | 'AXESS')[];
    deletionDate: StarjackDate<T>;
    expirationDate: StarjackDate<T>;
    external: boolean;
    firstname: string;
    gender: Gender;
    id: string;
    image: string;
    integrationRef: string;
    lastname: string;
    logo: string;
    productionDate: StarjackDate<T>;
    serialNumber: string;
    singleCardCodes: string[];
    status: KeycardStatus;
    tickets: Ticket<T>[];
    title: string;
    imageLastUpdatedAt: StarjackDateISO<T>;
};

export const convertKeycardToFrontend = (
    keycard: Keycard<BackendType>
): Keycard => ({
    ...keycard,
    birthday: convertDateFromDateArray(keycard.birthday),
    deletionDate: convertDateFromDateArray(keycard.deletionDate),
    expirationDate: convertDateFromDateArray(keycard.expirationDate),
    productionDate: convertDateFromDateArray(keycard.productionDate),
    tickets: keycard.tickets?.map(convertTicketToFrontend) || [],
    imageLastUpdatedAt: convertIsoDateStringToDate(keycard.imageLastUpdatedAt),
});
